export const UPSELL_TABS = [
  { id: 'packages', label: 'Pacotes avulsos' },
  { id: 'plans', label: 'Planos' },
]

export const PLAN_OPTIONS = [
  { id: 'essential', tier: 1, label: 'Essencial · 15 artes/mês', price: 'R$ 49,90 /mês' },
  { id: 'growth', tier: 2, label: 'Growth · 30 artes/mês', price: 'R$ 99,90 /mês' },
  { id: 'business', tier: 4, label: 'Business · 140 artes/mês', price: 'R$ 299,90 /mês' },
]

export const EXIT_FEEDBACK_OPTIONS = [
  { id: 'price', label: 'Um preço menor' },
  { id: 'trial', label: 'Poder testar mais' },
  { id: 'quality', label: 'Resultados de geração melhores' },
  { id: 'exploring', label: 'Nada — só explorando' },
]
